/**
 * 解决安卓下输入框被手机键盘遮挡问题
 */

if (/Android/gi.test(navigator.userAgent)) {
  // 检测userAgent是否为Android
  window.addEventListener("resize", function () {
    if (
      document.activeElement &&
      (document.activeElement.tagName == "INPUT" ||
        document.activeElement.tagName == "TEXTAREA")
    ) {
      // 判断当前active的元素是否为input/ textarea
      window.setTimeout(function () {
        document.activeElement && document.activeElement.scrollIntoView();
        // 原生方法，滚动至需要显示的位置
      }, 0);
    }
  });
}
